export default {
	namespaced: true,
	state: { sessions: [] },
	mutations: {
		setSession(state, session) {
			if (
				state.sessions.find(s => {
					return s.session == session.session
				})
			) {
				let current = state.sessions.find(s => {
					return s.session == session.session
				})

				current.active = session.active
				current.score = session.score
				current.steps = session.steps
				current.time = parseInt(session.time)
				if (!session.active) {
					current.totalTime = Math.round(
						(current.time - current.start) / 1000
					)
				}
			} else {
				session.start = session.session
				state.sessions.push(session)
			}
		},
	},

	actions: {
		setSession({ commit }, value) {
			commit('setSession', value)
		},
	},
}
